/* eslint-disable no-undef */
import { queryToObject } from "@/utils/common";
import { useAuthStore } from '@/stores/auth';
export const useAppStateStore = defineStore('appStateStore', () => {
  const authStore = useAuthStore();
  const {
    isUser
  } = storeToRefs(authStore);

  // STATE ------------------------------------------------------------------
  const initialized = ref(false);
  const fetchingBoxData = ref(false);
  const hasConfigurationId = ref(false);
  const hasSlug = ref(false);
  const useBoxQueryParametersError = ref(false);

  // COMPUTED ---------------------------------------------------------------
  const queryObject = computed(() => {
    return queryToObject(window.location.search);
  });
  const showConfigurator = computed(() => {
    if (!hasSlug.value && !hasConfigurationId.value) {
      return false;
    }

    // Needs to return false on no query so box list shows in dev

    if (!hasConfigurationId.value) {
      return true;
    }
    if (hasConfigurationId.value && isUser.value) {
      return true;
    }
    return false;
  });
  const componentToLoad = computed(() => {
    if (!initialized.value || fetchingBoxData.value) {
      return 'loading';
    }
    let component = '';
    if (!hasSlug.value && !hasConfigurationId.value) {
      component = 'start-here';
    }
    if (hasSlug.value) {
      component = !useBoxQueryParametersError.value ? 'configurator' : 'start-here';
    }
    if (!component && hasConfigurationId.value) {
      component = isUser.value ? 'configurator' : 'login';
      if (isUser.value && useBoxQueryParametersError.value) {
        component = 'my-account';
      }
    }
    return component;
  });

  // ACTIONS ----------------------------------------------------------------
  function setHasSlug() {
    hasSlug.value = queryObject.value?.slug ? true : false;
  }
  function setHasConfigurationId() {
    hasConfigurationId.value = queryObject.value?.id ? true : false;
  }
  function setQueryParamState() {
    setHasConfigurationId();
    setHasSlug();
    initialized.value = true;
  }
  function setUseBoxQueryParametersError(error) {
    useBoxQueryParametersError.value = error;
  }
  return {
    hasConfigurationId,
    showConfigurator,
    useBoxQueryParametersError,
    componentToLoad,
    fetchingBoxData,
    setQueryParamState,
    setUseBoxQueryParametersError
  };
});